/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamQuestionLibraryItemMutationRequest,
  PostApiV1ExamQuestionLibraryItemMutationResponse,
  PostApiV1ExamQuestionLibraryItem400,
  PostApiV1ExamQuestionLibraryItem401,
  PostApiV1ExamQuestionLibraryItem500,
} from "../../types/examQuestionLibraryController/PostApiV1ExamQuestionLibraryItem.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1ExamQuestionLibraryItemUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/exam/question-library/item` as const,
  };
  return res;
}

/**
 * @description Cria uma nova questão na biblioteca de questões. O tipo do componente determina quais campos são obrigatórios. Para questões de lista (Escolha Simples ou Múltipla Escolha), a lista de opções deve ser fornecida no campo ExamTypeList. **(Requer Authorization para autenticação)**
 * @summary Criar questão na biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/item}
 */
export async function postApiV1ExamQuestionLibraryItem(
  data: PostApiV1ExamQuestionLibraryItemMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ExamQuestionLibraryItemMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1ExamQuestionLibraryItemMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryItem400
      | PostApiV1ExamQuestionLibraryItem401
      | PostApiV1ExamQuestionLibraryItem500
    >,
    PostApiV1ExamQuestionLibraryItemMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamQuestionLibraryItemUrl().url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
